var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import { asText, SUCCESS_STATUS_CODE } from './service_helpers';
export var fetchFinanceProductOptions = function (programAspireOId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, rows, optionsByCode_1, error_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!programAspireOId) {
                    return [2, []];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4, api_service.get({
                        endPoint: api_urls.FINANCE_PRODUCT,
                        payLoad: { ProgramAspireOId: programAspireOId },
                        showLoader: false,
                    })];
            case 2:
                response = _b.sent();
                if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== SUCCESS_STATUS_CODE) {
                    return [2, []];
                }
                rows = Array.isArray(response.data.data)
                    ? response.data.data
                    : [];
                optionsByCode_1 = new Map();
                rows.forEach(function (row) {
                    var value = asText(row.Code);
                    var description = asText(row.Description) || value;
                    if (!value || optionsByCode_1.has(value)) {
                        return;
                    }
                    var isLoan = row.IsLoan === true || Number(row.IsLoan) === 1 ? 1 : 0;
                    optionsByCode_1.set(value, {
                        label: "".concat(isLoan ? 'Loan' : 'Lease', " - ").concat(description),
                        value: value,
                        isLoan: isLoan,
                    });
                });
                return [2, Array.from(optionsByCode_1.values())];
            case 3:
                error_1 = _b.sent();
                return [2, []];
            case 4: return [2];
        }
    });
}); };
export var fetchPricingOptionsByProduct = function (programAspireOId, statesList, amountFinanced) { return __awaiter(void 0, void 0, void 0, function () {
    var response, rows, optionsByCode_2, error_2;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!programAspireOId || statesList.length === 0) {
                    return [2, {}];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4, api_service.post({
                        endPoint: api_urls.GET_PRICING_DETAILS,
                        payLoad: {
                            ProgramAspireOId: programAspireOId,
                            StatesList: statesList.map(function (_a) {
                                var countryCode = _a.countryCode, stateCode = _a.stateCode;
                                return ({
                                    CountryCode: countryCode,
                                    StateCode: stateCode,
                                });
                            }),
                            AmountFinanced: amountFinanced,
                        },
                        showLoader: false,
                    })];
            case 2:
                response = _b.sent();
                if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== SUCCESS_STATUS_CODE) {
                    return [2, {}];
                }
                rows = Array.isArray(response.data.data)
                    ? response.data.data
                    : [];
                optionsByCode_2 = {};
                rows.forEach(function (row) {
                    var _a;
                    var code = asText(row.Code);
                    if (!code) {
                        return;
                    }
                    optionsByCode_2[code] = ((_a = row.PricingOptions) !== null && _a !== void 0 ? _a : [])
                        .map(function (option) { return ({
                        label: asText(option.Name),
                        value: asText(option.Name),
                        id: asText(option.Id),
                        pricingLevel: asText(option.PricingLevel),
                    }); })
                        .filter(function (option) { return option.label; });
                });
                return [2, optionsByCode_2];
            case 3:
                error_2 = _b.sent();
                return [2, {}];
            case 4: return [2];
        }
    });
}); };
